export const publicationFeeDetails = [
    {
        title: "Publication fee includes:",
        points: [
            "Plagiarism checking using Drill Bit software",
            "Formatting and editing of the submitted research content",
            "Hard copy of the journal and certificate of Publication to individual author",
            "Submission of research to indexing service",
            "Shipping charges",
            "Entire help pertaining to publication process"

        ]
    }
];

export const bankDetails = [
    {
        title: "Bank Details ",
        points: [
            { title: "Bank Name", value: "Tamilnad Mercantile Bank" },
            { title: "Branch", value: "Thalakulam" },
            { title: "Account No", value: "026150050304783" },
            { title: "IFSC Code", value: "TMBL0000026" },
        ]
    }
];

